import EpsgValidationModal from './EpsgValidationModal/EpsgValidationModal';
import XsdValidationModal from './XsdValidationModal/XsdValidationModal';
import ErrorModal from './ErrorModal/ErrorModal';

const modals = {
   EPSG_VALIDATION: EpsgValidationModal,
   XSD_VALIDATION: XsdValidationModal,
   ERROR: ErrorModal,
};

export default modals;